/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./userSetting.vue?vue&type=template&id=6e08b661&scoped=true&"
import script from "./userSetting.vue?vue&type=script&lang=js&"
export * from "./userSetting.vue?vue&type=script&lang=js&"
import style0 from "./userSetting.vue?vue&type=style&index=0&id=6e08b661&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e08b661",
  null
  
)

export default component.exports